export const setCookie = (name, value, days, domain, isTimeDiff = false) => {
	let expires = '';
	if (days) {
		const date = new Date();
		if (isTimeDiff) {
			date.setTime(date.getTime() + days);
		} else {
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		}
		expires = `; expires=${date.toGMTString()}`;
	}
	let cookie = `${name}=${value}${expires}; path=/`;
	if (domain) {
		cookie += `; domain=${domain}`;
	}
	document.cookie = cookie;
};

export const getCookie = (name) => {
	const nameEQ = `${name}=`;
	const ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
};

export const removeCookie = (name) => {
	setCookie(name, '', -1);
};
